export const sessionType: Record<"ALL_DAY" | "MORNING" | "AFTERNOON", number> =
  {
    ALL_DAY: 1,
    MORNING: 2,
    AFTERNOON: 3,
  };
